module.exports = __webpack_public_path__ + "img/green-circle.efc68dc4.svg";